import { api } from './api';
import { ApiResponse, AuthTokens, LoginCredentials, RegisterData } from '../types';

export const authService = {
  async register(data: RegisterData): Promise<AuthTokens> {
    const response = await api.post<ApiResponse<AuthTokens>>('/auth/register', data);
    return response.data.data!;
  },

  async login(credentials: LoginCredentials): Promise<AuthTokens> {
    const response = await api.post<ApiResponse<AuthTokens>>('/auth/login', credentials);
    return response.data.data!;
  },

  async logout(refreshToken: string): Promise<void> {
    await api.post('/auth/logout', { refreshToken });
  },

  async getProfile(): Promise<any> {
    const response = await api.get<ApiResponse>('/auth/profile');
    return response.data.data;
  },
};
